// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-loading {
  width: 35px;
  height: 35px;
  margin: 0 auto;
}
.container-loading .loading {
  margin: 100px 0 0 0;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/minha-conta/lancamentos-futuros/lancamentos-futuros.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AACF;AACE;EACI,mBAAA;AACN","sourcesContent":[".container-loading {\n  width: 35px;\n  height: 35px;\n  margin: 0 auto;\n\n  .loading {\n      margin: 100px 0 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
